import { BW_PHANT_URL } from '../config';
import StorageService from './storage.service';
import { FullUserModel } from 'src/types/user.model';
import { ApiError } from 'src/utils/error.utils';

export default class TrackingService {
    public static async track(params: any = {}): Promise<void> {
        const user: FullUserModel = StorageService.getReduxUserObject();
        // don't track demo user
        if (user?.attributes.demo) return;

        const queryString = Object.keys(params)
            .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            .join('&');

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: StorageService.getTestUserId()
            }
        };

        await fetch(`${BW_PHANT_URL}/track?${queryString}`, requestOptions);
    }

    public static async trackError(error: Error): Promise<void> {
        let trackingObject: any = {
            message: error.message
        };

        if (error instanceof ApiError) {
            trackingObject = {
                ...trackingObject,
                status: error.response.status,
                url: error.response.url
            };
        }

        await this.track(trackingObject);
    }
}
